import { Component, OnInit } from "@angular/core";

import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ToastService } from "@shared/service/toast.service";
import { MessageType } from "@schema/message";
import { confirmationValidator } from "@core/validator/confirmation-validator.directive";

@Component({
  selector: "app-change-password-modal",
  templateUrl: "./change-password-modal.component.html",
  styleUrls: ["./change-password-modal.component.scss"]
})
export class ChangePasswordModalComponent implements OnInit {

  /**
   * The form used on this modal
   */
  public form: FormGroup;

  public loading = false;

  /**
   * Grab the form controls
   */
  get formControls() {
    return this.form.controls;
  }

  constructor(
    public modal: NgbActiveModal,
    protected _fb: FormBuilder,
    protected _toastService: ToastService,
  ) { }

  ngOnInit() {
    this.form = this._fb.group({
      currentPassword: [null, [
        Validators.required
      ]],
      newPassword: [null, [
        Validators.required,
        Validators.minLength(8)
      ]],
      confirmNewPassword: [null, [
        Validators.required
      ]]
    }, {
      validators: confirmationValidator("newPassword", "confirmNewPassword")
    });
  }

  public submit() {
    console.log("submitted change password form");
    this.loading = true;

    const parent = this;
    // TODO: Call the user endpoint to check current password + success of new password

    // Dummy loading time / success:
    window.setTimeout(() => {
      /*parent.modal.close();
      parent.loading = false;
      parent._toastService.show({
        title: "Success!",
        body: `Your password has been updated!`,
        type: ToastType.success,
        autohide: true
      });*/

      parent.loading = false;
      parent.form.get("currentPassword").setErrors({
        invalidPassword: true
      });

    }, 1000);
  }

}
